import React from 'react'
import './Home.css';
import Illustration from '../../images/startpage-image.png'
import {Col, Container, Row} from 'react-bootstrap';

const Home = () => (
    <div className="Home">
            <Container id="homeJumbotronGrid">
                <Row className="show-grid">
                    <Col xs={12} s={12} md={12} lg={12} xl={12}>
                        <Container>
                            <Row>
                            <Col xs={12} s={12} md={12} lg={7} xl={7}>
                                <div className={"jumbotron pt-12 white welcome"}>
                                    <span className={"startingLine"}></span>
                                    <h2 className={"mt-3 mb-2"}>Välkommen</h2>
                                    <p>Ögonremiss är en tjänst för dig som Optiker, där du på ett enkelt och
                                        effektivt sätt kan skapa och skicka en remiss.</p>
                                </div>
                            </Col>
                            <Col xs={12} s={12} md={12} lg={5} className={"illustrationContainer"}>
                                <div className={"float-md-end jumbotron pt-4 pb-2 ps-3 pe-3 white"}>
                                    <img alt={'Ögonremiss illustration'} className={""} src={Illustration}/>
                                </div>
                            </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row className="show-grid">
                    <Col xs={12} s={12} md={12} lg={12} xl={12}>
                        <Container>
                            <Row>
                            <Col xs={12} s={12} md={12} lg={6} xl={6}>
                                <div className={"jumbotron p-5 mb-4 text-white shadow"}>
                                    <span className={"startingLine float-start"}></span>
                                    <h1 className={"mb-2 responsive-title"}>För optiker</h1>
                                    <p className="responsive-paragraph">Som Optiker kan du nu skicka in din remiss elektronisk.
                                        Läs mer om vilka landsting som är anslutna samt hur det fungerar.</p>
                                    <a href={"/info/#beskrivning"} className={"float-end btn"}>Mer info</a>
                                </div>
                            </Col>
                            <Col xs={12} s={12} md={12} lg={6} xl={6}>
                                <div className={"float-md-end jumbotron p-5 mb-4 text-white hangDown"}>
                                    <span className={"startingLine float-start"}></span>
                                    <h1 className={"mb-2 responsive-title"}>Skicka en remiss</h1>
                                    <p className="responsive-paragraph">Logga In och skicka en remiss, eller ta del av information om hur du får tillgång till tjänsten.</p>
                                    <a href={"/info/#beskrivning"} className={"float-end btn"}>Mer info</a>
                                </div>
                            </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                {/*<Row style={{height:'64px'}}/>*/}
                {/*<Row className="show-grid">*/}
                    {/*<Col xs={12} md={7} lg={7}>*/}
                        {/*<Container>*/}
                            {/*<Row>*/}
                            {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*<Col xs={10} md={10} lg={10}>*/}
                                {/*<Jumbotron className={"white description"}>*/}
                                    {/*<span className={"startingLine"}></span>*/}
                                    {/*<h2 id="beskrivning">Om tjänsten</h2>*/}
                                    {/*<p>Ögonremiss är en tjänst för dig som Optiker, där du på ett enkelt och effektivt sätt kan skapa och skicka en remiss elektroniskt till mottagaren.*/}
                                        {/*Ta kontakt med den mottagning som du brukar skicka era remisser till, så kan de meddela om de är anslutna till tjänsten ögonremiss.se.*/}
                                        {/*Om mottagaren är ansluten, kommer Ni få ett mail från ögonremiss.se där du får möjlighet att logga in med unikt lösenord. När du är inloggad kan du fylla i information om patienten och skicka remissen elektroniskt till mottagaren. Allt du behöver göra efter att remissen är ifylld, är att klicka på knappen skicka. Du kommer få en bekräftelse på att remissen är inskickad direkt på skärmen i form av en PDF. PDF’en kan du välja att spara, skriva ut och ge till patienten eller helt enklat stänga ner. Remissen som skickas till mottagaren kommer läsas in elektroniskt i mottagares journalsystem, och patient kommer bli kontaktad på vanligt sätt av mottagaren efter att en läkare bedömt remissen.*/}
                                        {/*All kommunikation mellan din dator och mottagande journalsystem sker krypterat och med de säkerhetsfunktioner som krävs och godkänts av mottagaren och berörda myndigheter. Ingen patientinformation lagras på någon annanstans än hos i mottagarens journalsystem på vanligt sätt.*/}
                                    {/*</p>*/}
                                {/*</Jumbotron>*/}
                            {/*</Col>*/}
                            {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*</Row>*/}
                            {/*<Row>*/}
                            {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*<Col xs={10} md={10} lg={10}>*/}
                                {/*<Jumbotron className={"white about"}>*/}
                                    {/*<span className={"startingLine"}></span>*/}
                                    {/*<h2 id="omoss">Om oss</h2>*/}
                                    {/*<p>Ögonremiss.se är en tjänst för utvecklad av Bluebrick AB i samråd med*/}
                                        {/*Region Jämtland Härjedalen för att förenkla och*/}
                                        {/*förbättra hanteringen av ögonremisser.</p>*/}
                                {/*</Jumbotron>*/}
                            {/*</Col>*/}
                                {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*</Row>*/}
                            {/*<Row>*/}
                            {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*<Col xs={10} md={10} lg={10}>*/}
                                {/*<Jumbotron className={"white contact"}>*/}
                                    {/*<span className={"startingLine"}></span>*/}
                                    {/*<h2 id="kontakt">Kontakt</h2>*/}
                                    {/*<p>Har du frågor om inloggning eller om remisser som du skickat.*/}
                                        {/*Kontakta den enhet som tar emot dina remisser.*/}
                                        {/*Om du idag inte har inloggning till ögonremiss.se, så ber vi er kontakta*/}
                                        {/*den mottagare som du normalt skickar dina remisser*/}
                                        {/*till för att bli registrerad.</p>*/}
                                {/*</Jumbotron>*/}
                            {/*</Col>*/}
                                {/*<Col xs={1} md={1} lg={1}></Col>*/}
                            {/*</Row>*/}
                        {/*</Container>*/}
                    {/*</Col>*/}

                {/*</Row>*/}
            </Container>
    </div>
)
export default Home